<template>
    <div class="p-4">
        <l-container class="mb-4">
            <l-container-title slot="toolbar" text="Users" icon="users-cog" color="bg-black" />
            <l-info-box class="mb-4" :active="users.length > 0">Rightclick on a row to edit or delete</l-info-box>
            <div class="flex w-full justify-between">
                <div v-if="!showAddUserPanel">
                    <l-button type="success" @click="showAddUserPanel = true">
                        <font-awesome-icon icon="user-plus" class="text-xl text-white" />
                        New user
                    </l-button>
                </div>
                <div v-if="showAddUserPanel" class="rounded border w-full">
                    <div class="m-2 container">
                        <div class="w-64 float-left">
                            <div class="w-64">
                                <b>Email/username</b>
                                <br />
                                <l-input placeholder="Email/username" v-model="newObj.username" inputClass="text-2xs" />
                            </div>
                            <div class="w-1">
                            </div>

                            <div class="w-64">
                                <b>Name</b>
                                <br />
                                <l-input placeholder="Name" v-model="newObj.name" inputClass="text-2xs" />
                            </div>
                            <div class="w-1">
                            </div>
                            <div class="w-64">
                                <b>Password</b>
                                <br />
                                <div class="w-56 float-left"><l-input placeholder="Passord" :type="passwordFieldType" v-model="newObj.password" inputClass="text-2xs" /></div>
                                <div class="w-8 pt-2 pl-2 float-left">
                                    <font-awesome-icon v-if="passwordFieldType=='password'" icon="eye-slash" class="text-xl cursor-pointer" @click="switchVisibility" title="Vis passord" />
                                    <font-awesome-icon v-if="passwordFieldType=='text'" icon="eye" class="text-xl cursor-pointer" @click="switchVisibility" title="Skjul passord" />
                                </div>
                            </div>

                        </div>
                        <div class="w-auto float-left ml-6">
                            <div class="w-64">
                                <b>Groups</b>
                                <br />
                                <div class="w-56 float-left">
                                    <l-select2 v-model="groupSelection" placeholder="Velg gruppe(r)" :multiple="false" :options="groupSelectionList" :clearable="false" />
                                </div>
                                <div class="w-4 pl-2 pt-1 float-left cursor-pointer">
                                    <font-awesome-icon icon="user-tag" class="text-xl " @click="showAddGroupModal=true" title="New group" />
                                </div>
                                <div v-for="group in selectedgroups" class="w-auto float-left">
                                    <l-badge :showRemove="true" @close="removeGroup(group)">{{group.label}}</l-badge>
                                </div>
                            </div>
                        </div>
                        <div class="w-full pt-1">

                        </div>
                        <div class="w-full p-3 clearfix">
                        </div>
                        <div class="w-full">
                            <l-button type="success"
                                    :disabled="newObj.username=='' || newObj.password==''"
                                    :title="(newObj.username=='' || newObj.password=='')? 'Username and password required' : ''"
                                    @click="onAddUserSave">Save</l-button>
                            <l-button type="danger" @click="onAddUserClose">Close</l-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex w-full justify-between">
            </div><br />
            <hot-table :data="users" :settings="settings" ref="hot">
                <hot-column title="Name" data="name" read-only="true"></hot-column>
                <hot-column title="Username/email" data="username" read-only="true"></hot-column>
                <hot-column title="Groups" data="groups_cs" read-only="true"></hot-column>
                <hot-column title="Created" data="created" read-only="true"></hot-column>
            </hot-table>
        </l-container>
        <GroupEdit :showing="showAddGroupModal" @close="closeNewGroupModal" @afterSave="afterGroupAddSave"></GroupEdit>
        <UserEdit :showing="edit" @close="edit = false" :selected="selected" @save="updateUser" :groupSelectionList="groupSelectionList"></UserEdit>

    </div>
</template>

<script>
    //import * as moment from "moment";
    import { LInput, LButton, LSelect2, LBadge } from "@/components/forms";
    import Notify from "@/helpers/notify";
    import HandsontableHelper from "@/helpers/settings/handsontable";
    import "handsontable/dist/handsontable.full.css";
    import { HotTable, HotColumn } from "@handsontable/vue";
    import Handsontable from "handsontable";
    import LInfoBox from "@/components/LInfoBox";
    import UserManagementService from "./usermanagement.service";
    import GroupEdit from "./GroupEdit";
    import UserEdit from "./UserEdit";
    import ContextMenu from "./context.menu";

    export default {
        name: "Users",
        components: {
            HotTable,
            HotColumn,
            LInput,
            LButton,
            LInfoBox,
            LSelect2,
            LBadge,
            GroupEdit,
            UserEdit
        },

        data() {
            return {
                edit: false,
                users: [],
                settings: HandsontableHelper.settings(false),
                newObjTempl: { name: '', email: '', password: '', },
                newObj: { name: '', email: '', password: '', },
                showAddUserPanel: false,
                showAddGroupPanel: false,
                passwordFieldType: 'password',
                selectedgroups: [],
                groupSelectionList: [],
                groupSelection: [],
                showAddGroupModal: false,
                selected: {}

            };
        },

        mounted() {
            Notify.loadData(null, this.loadInitialData);
            this.settings.contextMenu = ContextMenu(this);
        },
        watch: {
            groupSelection: function (val) {
                if (val.length == 0) return;
                if (!this.selectedgroups.includes(val)) this.selectedgroups.push(val);
                this.groupSelection = [];
            }
        },
        methods: {
            async loadInitialData() {
                this.users = await UserManagementService.users();
                console.log(this.users);
                this.groupSelectionList = await UserManagementService.groupSelectList();
            },
            async onAddUserSave() {
                await Notify.loadData("Saving '" + this.newObj.name + "'", this.saveUser, JSON.parse(JSON.stringify(this.newObj)), JSON.parse(JSON.stringify(this.selectedgroups)));
                Notify.loadData(null, this.loadInitialData);
            },
            onDeleteUser(t, o) {
                const clickedRow = o[0].start.row;
                const hot = this.$refs.hot.hotInstance;
                const physicalIndex = hot.toPhysicalRow(clickedRow);
                let row = hot.getSourceDataAtRow(physicalIndex);
                Notify.prompt(async response => {
                    if (response) {
                        await Notify.loadData("Deleting user...", async () => {
                            const rowsAffected = await UserManagementService.deleteUser(row.id);
                            this.loadInitialData;
                            const activeEditor = hot.getActiveEditor();
                            hot.alter("remove_row", clickedRow, 1);
                            Notify.success("User have been deleted");
                        });
                    }
                }, "Are you sure you want to delete this user?");
            },
            onEditUser(t, o) {
                const clickedRow = o[0].start.row;
                const hot = this.$refs.hot.hotInstance;
                const physicalIndex = hot.toPhysicalRow(clickedRow);
                let row = hot.getSourceDataAtRow(physicalIndex);
                this.selected = row;
                this.edit = true;
            },
            async saveUser(user, groups) {
                await UserManagementService.addUser(user, groups);
            },
            async onAddUserClose() {

                this.newObj = this.newObjTempl;
                this.showAddUserPanel = false;

            },
            switchVisibility() {
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            },
            removeGroup(val) {
                this.selectedgroups.splice(this.selectedgroups.indexOf(val), 1);
            },
            closeNewGroupModal() {
                this.showAddGroupModal = false;
            },
            async updateUser(user) {
                await Notify.loadData("Saving changes for '" + user.name + "'", UserManagementService.updateUser, user);
                Notify.loadData(null, this.loadInitialData);
                ;
            },
            async afterGroupAddSave(g) {
                var sel = { label: g.Name, value: g.Id };
                this.groupSelectionList.push(sel);
                this.selectedgroups.push(sel);

                this.groupSelectionList = await UserManagementService.groupSelectList();
            }

        }
    };
</script>
<style>
    .file-uploads {
        background: #efefef;
        height: 100px;
        vertical-align: middle;
    }

        .file-uploads span {
            position: relative;
            top: 40px;
            vertical-align: middle;
        }
</style>